export default __webpack_public_path__ + "aa396b8.png";